export const deletereq="deletereq"
export const deletesucc="deletesucc"
export const deletefail="deletefail"